module.exports = __webpack_public_path__ + "img/video-icon.6c89f7e7.png";